'use strict';

import React, { Component } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import { etablishment as etablishment_icons } from 'Components/IconsConfigs';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import Link from 'Pure/Link';
import Logo from 'Pure/Logo';
import truncate from 'Functions/truncate';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import { distance, formatNum, isTrue } from 'Shared/utilities';
import { URL, action } from 'Shared/Routes';
import { coworking_place_types as type_options } from 'Shared/options';
import { etablishment_equipments } from 'Shared/options';
const {
  app,
  qwest
} = window;
const pos_fields = ['min_lat', 'max_lat', 'min_lng', 'max_lng'];
export default class SearchedEstablishments extends Component {
  state = {
    loading: false,
    data: [],
    data_count: this.props['items-per-page'] || 6,
    page: 0,
    rows_per_page: this.props['items-per-page'] || 6,
    order: this.props['order'] || 'asc',
    order_by: this.props['order-by'] || 'name',
    width: window.innerWidth,
    type: app.state.session.user?.roles?.includes?.('company_employee') ? 'lounge' : window.localStorage.getItem('widget-space-type') || 'all',
    date: window.localStorage.getItem('widget-date') || '',
    skip: 0,
    limit: 0,
    title: 'Nos différents établissements'
  };
  distance = distance.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.search_mode !== 'around') {
      component.fetch({});
    } else if (props.user_location) {
      component.fetch({});
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.search_mode === 'around' && prev_props.user_location !== props.user_location) {
      component.fetch({});
    } else if (props['show-only-in-boundaries']) {
      const updated = pos_fields.some(field => prev_props[field] !== props[field]);
      if (updated) {
        component.setShown();
      }
    }
  }
  getInfosFromUrl = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const params = {};
    let pathname = document.location.pathname;
    if (pathname.endsWith('/')) pathname = pathname.slice(0, -1);
    const url_type = pathname.split('/')[2];
    if (url_type === 'seminaires') {
      params.type = 'meeting';
    } else if (url_type) {
      const match = type_options.find(opt => opt.value === url_type || opt.new_value === url_type);
      params.type = match ? match.new_value : 'all';
    }
    if (props.search_mode === 'around') {
      return params;
    }
    params.searched = decodeURI((document.location.href.split('?')[0] || '').replace(document.location.origin, '').split('/')[3] || '');
    return params;
  };
  fetch = ({
    searched,
    type,
    date,
    page
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const url_params = component.getInfosFromUrl();
    const search_mode = props.search_mode;
    const current_page = typeof page === 'undefined' ? state.page : page;
    const used_type = typeof type === 'undefined' ? state.type : type;
    component.setState({
      loading: true,
      type: used_type
    });
    qwest.post(action('searchAllEtablishments'), {
      limit: props.slider === true ? 0 : state.rows_per_page,
      skip: props.slider === true ? 0 : state.rows_per_page * current_page,
      front_page_order: props.slider === true,
      searched: typeof searched === 'undefined' ? decodeURI(state.searched || '') : decodeURI(searched || ''),
      search_mode: search_mode,
      user_location: props.search_mode === 'around' ? props.user_location : undefined,
      type: used_type,
      date: typeof date === 'undefined' ? state.date : date,
      order: 'asc',
      order_by: 'front_page_order',
      ...url_params
    }).then(function (xhr, response) {
      let title = (response.data?.length || 0) + ' Résultat';
      if (response.data?.length > 1) {
        title += 's';
      }
      const establishments = (response.data || []).map(function (data) {
        data.description = truncate(data.description, 160);
        return data;
      });
      component.setState({
        loading: false,
        data_count: response.count || 0,
        data: establishments,
        shown_data: establishments.slice(0),
        width: window.innerWidth,
        searched_lat: response.lat,
        searched_lng: response.lng,
        render_id: uniqid(),
        title: title
      });
      if (props.onFetch instanceof Function) {
        props.onFetch({
          data: response.data || []
        });
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  setShown = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const shown = (state.data || []).filter(function ({
      geometry
    }) {
      const {
        lat,
        lng
      } = geometry.location;
      return lat > props.min_lat && lat < props.max_lat && lng > props.min_lng && lng < props.max_lng;
    });
    component.setState({
      shown_data: shown
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const modifiers = ['etablishment'].concat(props.bemit || []);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let etablishments = (state.shown_data || []).map(function (data, i) {
      let link = '/' + ['etablissements', data.slug].join('/');
      const params = [];
      const type = props.type;
      const date = props.date;
      if (type && type !== 'all') {
        params.push({
          name: 'type',
          value: type
        });
      }
      if (date) {
        params.push({
          name: 'date',
          value: date
        });
      }
      params.forEach(function ({
        name,
        value
      }, i) {
        link += i === 0 ? '?' : '&';
        link += name + '=' + value;
      });
      let distance;
      if (state?.searched_lat && state?.searched_lng) {
        distance = component.distance({
          lat1: data?.geometry?.location?.lat,
          lat2: state.searched_lat,
          lng1: data?.geometry?.location?.lng,
          lng2: state.searched_lng
        });
      }
      const icons = etablishment_equipments.filter(infos => (data.service || []).includes(infos.value)).map(function (infos) {
        const icons_info = etablishment_icons.find(data => data.value === infos.value);
        if (!icons_info) return null;
        const Icon = icons_info.icon;
        const output = /*#__PURE__*/React.createElement("div", {
          className: "c-media__icon",
          key: infos.value
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "c-media__icon-svg"
        }), /*#__PURE__*/React.createElement("div", {
          className: "u-readers-only"
        }, infos.label || infos.value));
        return output;
      });
      const city = data.address?.city;
      let output = /*#__PURE__*/React.createElement(Link, {
        className: bemit('c-media', modifiers),
        key: data.id,
        href: link
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__img-container"
      }, isTrue(data.not_configured) ? /*#__PURE__*/React.createElement("span", {
        className: "c-media__color-label"
      }, "Ouverture prochaine") : undefined, data.images[0] ? /*#__PURE__*/React.createElement(Image, {
        className: "c-media__img",
        src: variant({
          img: data.images[0],
          size: 600
        }),
        alt: data.name
      }) : /*#__PURE__*/React.createElement(Logo, {
        className: "c-media__img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "c-media__texts"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__title"
      }, data.name, city ? ' - ' + city : undefined, distance > 1 ? ' ' : undefined, distance > 1 ? formatNum(distance / 1000, '0,0[.]0') + 'km' : undefined), /*#__PURE__*/React.createElement("div", {
        className: "c-media__icons"
      }, icons))));
      return output;
    });
    const missing_permissions = props.search_mode === 'around' && !props.user_location;
    let output = /*#__PURE__*/React.createElement("section", {
      className: bemit('o-spaces-block', modifiers)
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__children"
    }, props.children), /*#__PURE__*/React.createElement("header", {
      className: "o-spaces-block__header"
    }, props.user_location_timeout ? getFormStatus({
      error: 'L\'accès à votre localisation semble bloqué, vérifiez vos paramètres (navigateur, VPN, etc.) si vous souhaitez utiliser cette fonction.'
    }, ['v2']) : missing_permissions ? getFormStatus({
      statement: 'Vous devez autoriser la localisation pour voir les établissements proches.'
    }, ['v2']) : /*#__PURE__*/React.createElement("h2", {
      className: "c-title"
    }, state.title), missing_permissions ? undefined : state.shown_data?.length !== state.data?.length ? /*#__PURE__*/React.createElement("div", {
      className: "map-results-count"
    }, /*#__PURE__*/React.createElement("span", {
      className: "map-results-count__bubble"
    }, state.shown_data?.length, '/', state.data?.length), /*#__PURE__*/React.createElement("span", {
      className: "map-results-count__txt"
    }, "sur la carte")) : undefined), props['with-home-btn'] ? /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__link"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['blue', 'front']),
      component: Link,
      href: URL('HomePage')
    }, "Retour \xE0 l'accueil")) : undefined), /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__list"
    }, etablishments), loader);
    return output;
  }
}
